/* unplugin-vue-components disabled */import script from "./log.vue?vue&type=script&setup=true&name=JobLog&lang=js"
export * from "./log.vue?vue&type=script&setup=true&name=JobLog&lang=js"

const __exports__ = script;

export default __exports__